module.exports = __webpack_public_path__ + "static/media/frequency.ebb79c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/frequency.png
// module id = 566
// module chunks = 0